// extracted by mini-css-extract-plugin
module.exports = {"imgCol":"feature-section_imgCol__yFfGd"};